import React from "react";
import styles from "../../../pages/styles";

const TextAreaField = ({
  title,
  name,
  value,
  onChange,
  placeholder,
  className,
  dark = false,
}) => (
  <div className={`${dark ? styles.paragraphwhite : styles.paragraph} mb-0`}>
    {title}
    <textarea
      cols="10"
      rows="5"
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`w-full text-base border-2 rounded-2xl px-4 py-2 focus:outline-none col-span-2 ${
        dark 
          ? "bg-white/10 backdrop-blur-sm border-white/30 text-white placeholder-white/50 focus:border-orangeprimary" 
          : "border-pinkprimary focus:border-blueprimary"
      }`}
    ></textarea>
  </div>
);

export default TextAreaField;
